import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixAnimations from 'wix-animations';
import { getMasterSearchResults, getSearchResultsForSearchPage, collectUserSearchValue } from 'backend/searchQuery';

const searchPage = wixLocation.path.includes('search');

// Loading animation
const loadingTimeline = wixAnimations.timeline({ repeat: -1 });
const hideLoadingTimeline = wixAnimations.timeline();

// SearchResults
const EDITORX_BLUE = '#003dff';
const MAX_RESULTS_TO_SHOW = 3;
let ALL_RELEVANT_RESULTS = [];
const DEFAULT_SEARCH_RESULTS = [{ // Used when search input is empty;
    _id: '1',
    category: 'VIDEO LIBRARY',
    title: 'Introducing Editor X',
    description: 'Discover the Editor X workspace. Get an introduction to your advanced layouting tools and an overview of responsive web design features like breakpoints, flexbox and CSS grid.',
    thumbnail: 'https://static.wixstatic.com/media/0d6674_6eb43b8cc7214bff888d2ae98d49fdb0~mv2.png',
    altText: 'Video tutorial introducing the Editor X workspace with an overview of the responsive layouting and design tools.',
    link: 'https://www.editorx.com/academy/video-tutorials/introducing-editor-x',
    type: 'Video Tutorial'
}, {
    _id: '2',
    category: 'VIDEO LIBRARY',
    title: 'Getting Started',
    description: 'Learn the basics of creating a site on Editor X. Get a step by step walkthrough covering the key features and capabilities.',
    thumbnail: 'https://static.wixstatic.com/media/0d6674_33b920e335504c7bbd965182f1dd53e8~mv2.png',
    altText: 'Video introducing the Editor X workspace with an overview of the responsive layouting tools and design capabilities.',
    link: 'https://www.editorx.com/academy/video-tutorials/getting-started',
    type: 'Video Tutorial'
}, {
    _id: '3',
    category: 'LESSONS & EXERCISES',
    title: 'Hover Interactions',
    description: 'Design dynamic web experiences by adding a variety of interactions to any element on hover. Customize the interaction settings for every breakpoint, from transform adjustment to advanced design capabilities and timing control.',
    thumbnail: 'https://static.wixstatic.com/media/0d6674_f4c0093e18824bf5a3015a3f7ec201e7~mv2.png',
    altText: 'Thumbnail indicating interactions. Orange background with a shaded orange container over it. In the middle of the container is a white logo.',
    link: 'https://www.editorx.com/academy/lessons/interactions',
    type: 'Lesson'
}];

export function activateSearch() {
    toggleSearchWindow();
}

function toggleSearchWindow() {
    const input = $w('#searchInput');
    const searchSection = $w('#searchSection');
    const closeSearchBtn = $w('#closeSearchBtn');
  

    input.onClick(() => {
        if (searchSection.collapsed)
            openSearchSection();
    });

    if (!searchPage) {
        closeSearchBtn.onClick(async () => { await closeSearchSection(); });
        $w('#searchBackdropBox').onClick(() => { closeSearchSection(); });
    }
}

function openSearchSection() {
    const searchSection = $w('#searchSection');
    const searchContentContainer = $w('#searchContentContainer');

    searchSection.expand().then(() => {
        searchSection.show().then(() => {
            getWindowSize().then(winHeight => {
                wixAnimations.timeline()
                    .add(searchContentContainer, { y: -winHeight.height, duration: 0 })
                    .add(searchContentContainer, { y: 0, opacity: 1, duration: 500 })
                    .play();
            });
        });
    });

}

function closeSearchSection() {
    const searchSection = $w('#searchSection');
    const searchContentContainer = $w('#searchContentContainer');

    getWindowSize().then(winHeight => {
        searchSection.collapse();
        wixAnimations.timeline()
            .add(searchContentContainer, { y: -winHeight.height, opacity: 0, duration: 500 })
            .onComplete(() => {
                searchSection.collapse();
            })
            .play();
    });

}

function setRepeaterToDefaultData() {
    let searchMainTitle;
    let resultsCountTitle;
    let repeater;

    if (searchPage) {
        searchMainTitle = $w('#searchPageTitle');
        resultsCountTitle = $w('#searchPageTotalResultsTitle');
        repeater = $w('#searchPageRepeater');
    } else {
        searchMainTitle = $w('#searchMainTitle');
        resultsCountTitle = $w('#resultsCountTitle');
        repeater = $w('#relevantSearchRepeater');
    }

    repeater.data = DEFAULT_SEARCH_RESULTS;
    searchMainTitle.text = `Top searches`;
    resultsCountTitle.text = `People are searching for`;
}

function getWindowSize() {
    return wixWindow.getBoundingRect()
        .then((windowSizeInfo) => {
            return {
                height: windowSizeInfo.window.height,
                width: windowSizeInfo.window.width
            }
        });
}

//============================
//    Search functionality
//============================
const EXCLUSE_SEARCH_INPUT_KEYS = ['Shift', 'Control', 'Meta', 'alt', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Tab', ];
const EXCEPTIONS_INPUTS = {
    vh: 'Sizing',
    VH: 'Sizing',
    vw: 'Sizing',
    VW: 'Sizing',
    "%": 'Sizing',
    cascading: 'breakpoints',
    Cascading: 'breakpoints',
    "viewport height": 'Sizing',
    "viewport width": 'Sizing'
}

let debounceTimer;
export function searchInput() {
    if (wixWindow.formFactor === "Desktop") {
        activateDesktopSearch();
    } else {
        activateMobileSearch();
    }
}

function activateDesktopSearch() {
    setLoadingSliderTimeline();

    $w('#searchInput').onKeyPress((event) => {
        if (EXCLUSE_SEARCH_INPUT_KEYS.every((key) => key !== event.key)) {
            if (debounceTimer) {
                clearTimeout(debounceTimer);
                debounceTimer = null;
            }
            if (searchPage) {
                getSearchForSearchPage(event, $w('#searchInput'))
            } else {
                getSearchForMasterSearch(event, $w('#searchInput'))
            }
        }
    })
}

//==== SEARCH FOR TABLET & MOBILE ====//

function activateMobileSearch() {
    let searchInput = $w('#tabletMobileSearchInput');

    toggleTableMobileSearch();

    searchInput.onKeyPress((event) => {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        getSearchForMobile(event, searchInput);
    });
}

function toggleTableMobileSearch() {
    const toggleSearch = $w('#toggleSearchTabletMobileOnly');
    const searchBox = $w('#tabletMobileSearchInputBox');
    const searchInput = $w('#tabletMobileSearchInput');

    toggleSearch.onClick(() => {
        if (searchBox.collapsed) {
            searchBox.expand().then(() => {
                setTimeout(async () => {
                    await searchInput.focus();
                }, 500)
            });
        } else {
            searchBox.collapse();
            searchInput.blur();
        }
    });
}

async function getSearchForMobile(event, inputElement) {
    let value = inputElement.value.trim();
    if (value.length > 1) {
        if (event.key === 'Enter') {
            debounceTimer = setTimeout(() => {
                collectUserSearchValue(value);
                wixLocation.to(`/search?q=${inputElement.value}`);
                $w('#tabletMobileSearchInputBox').collapse();
            }, 100);
        }
    }
}

//==== SIDEBAR MASTER: SEARCH RESULTS ====//
function getSearchForMasterSearch(event, inputElement) {
    if (event.key === 'Enter' && !searchPage) // For A11Y
        openSearchSection();

    $w('#relevantSearchRepeater').data = [];
    playLoading();

    debounceTimer = setTimeout(() => {
        let searchValue = inputElement.value.trim();

        if (searchValue.length > 1) {
            getSearchResultes(searchValue);
        } else {
            setRepeaterToDefaultData();
            stopLoading();
            $w('#seeAllResultsButton').hide();
        }
    }, 1000);
}

function assignMostRelevantSearchResultsToUI(queryResults) {
    $w('#relevantSearchRepeater').data = queryResults;
}

function updateMasterSearchResultTitle(queryDataLength) {
    const resultsCountTitle = $w('#resultsCountTitle');
    const searchMainTitle = $w('#searchMainTitle');
    const seeAllResultsBtn = $w('#seeAllResultsButton');

    if ($w('#searchInput').value.length !== 0) {
        let searchValue = encodeURI($w('#searchInput').value).replace(/%20/g, " ");
        searchMainTitle.html = `<p>Search results for "<b style="color: ${EDITORX_BLUE}">${searchValue}</b>"</p>`;

        if (queryDataLength <= 3) {
            if (queryDataLength === 0) {
                seeAllResultsBtn.show();
                resultsCountTitle.text = 'Try another search term.'
            } else {
                seeAllResultsBtn.hide();
            }
        } else {
            seeAllResultsBtn.show();
        }
        resultsCountTitle.text = `${queryDataLength} results found`;
    } else {
        seeAllResultsBtn.hide();
        setRepeaterToDefaultData(); // Fill the repeater with default data (new in academy).
    }
}

//==== SEARCH PAGE: SEARCH RESULTS ====//
function getSearchForSearchPage(event, inputElement) {

    if (EXCLUSE_SEARCH_INPUT_KEYS.every((key) => key !== event.key)) {
        $w('#searchPageRepeater').data = [];
        playLoading();

        debounceTimer = setTimeout(() => {
            updateQueryParams(inputElement.value);
            let searchValue = inputElement.value.replace(/\s*$/, '');

            if (searchValue !== '') {
                if (searchValue.length > 2) {
                    // getSearchResultes(searchValue);
                } else {
                    stopLoading();
                }
                stopLoading();
            } else {
                setRepeaterToDefaultData()
                stopLoading();
            }
        }, 1000);
    }
}

function updateQueryParams(searchValue) {
    wixLocation.queryParams.add({
        "q": searchValue,
    });
}

function assignSearchPageSearchResultsToUI(queryResults) {
    $w('#searchPageRepeater').data = queryResults;
}

function updateSearchPageSearchResultTitle(queryDataLength) {
    const searchMainTitle = $w('#searchPageTitle');
    const resultsCountTitle = $w('#searchPageTotalResultsTitle');

    if ($w('#searchInput').value.length !== 0) {
         let searchValue = encodeURI($w('#searchInput').value).replace(/%20/g, " ");
        searchMainTitle.html = `<p>Search results for "<b style="color: ${EDITORX_BLUE}">${searchValue}</b>"</p>`;

        if (queryDataLength > 0) {
            resultsCountTitle.text = `${queryDataLength} results found`;
            $w('#filterBox').expand();
            if (queryDataLength <= 3) {
                // if (queryDataLength === 0) {
                //     resultsCountTitle.text = 'Try another search term.'
                // }
            }
        } else {
            resultsCountTitle.text = 'Try another search term.'
            $w('#filterBox').collapse()
        }
    } else {
        $w('#filterBox').collapse()
        resultsCountTitle.text = `People are searching for`;
        setRepeaterToDefaultData(); // Fill the repeater with default data (new in academy).
    }
}

//==== GET SEARCH RESULTS FOR ALL SEARCH INPUTS ====//
async function getSearchResultes(searchValue) {
    if (searchPage) {
        // stopLoading();
        await getSearchResultsForSearchPage(searchValue)
            .then(queryResults => {
                assignSearchPageSearchResultsToUI(queryResults);
                updateSearchPageSearchResultTitle(queryResults.length);
            }).then(() => {
                stopLoading();
            });
    } else {
        await getMasterSearchResults(searchValue)
            .then(queryResults => {
                ALL_RELEVANT_RESULTS = queryResults.results;
                assignMostRelevantSearchResultsToUI(queryResults.results);
                updateMasterSearchResultTitle(queryResults.totalResults);
            })
            .then(() => {
                stopLoading();
            });
    }
    collectUserSearchValue(searchValue);
}

//==== LOADING ANIMATION ====//
function setLoadingSliderTimeline() {
    if (searchPage) {
        loadingTimeline.add($w('#searchPageSliderScreen'), { x: 500, duration: 500, easing: 'easeLinear' });
        hideLoadingTimeline.add($w('#searchPageSliderBox'), { opacity: 1, duration: 500, easing: 'easeLinear' });
    } else {
        loadingTimeline.add($w('#masterSearchSliderScreen'), { x: 500, duration: 500, easing: 'easeLinear' });
        hideLoadingTimeline.add($w('#masterSearchSliderBox'), { opacity: 1, duration: 500, easing: 'easeLinear' });
    }
}

function playLoading() {
    loadingTimeline.play();
    hideLoadingTimeline.play();
}

function stopLoading() {
    loadingTimeline.pause();
    hideLoadingTimeline.reverse();
}